import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            最近更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最新的漫画章节更新</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap transition-colors"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="space-y-3">
        {latest.map((comic) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors duration-200 group cursor-pointer"
          >
            <div className="w-14 h-[72px] flex-shrink-0 rounded overflow-hidden">
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 truncate">
                  {comic.title}
                </h3>
                {comic.isNew && (
                  <span className="text-[10px] bg-accent-500 text-background-50 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                    NEW
                  </span>
                )}
              </div>
              <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{comic.author}</p>
              <p className="text-xs text-primary-500 mt-1 whitespace-nowrap">
                第{comic.chapters[0]?.number}话 · {comic.chapters[0]?.title}
              </p>
            </div>
            <div className="text-right flex-shrink-0">
              <p className="text-xs text-foreground-400 whitespace-nowrap">{comic.updatedAt}</p>
              <p className="text-[10px] text-foreground-500 mt-0.5 whitespace-nowrap">
                共{comic.chapters.length}话
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}